<template>
  <div>
    <div v-if="!loading && fandoms[fandomIndex] && prompts[fandomIndex] != undefined">
      <h3>{{ fandoms[fandomIndex].name }} <span v-if="prompts[fandomIndex]">({{ prompts[fandomIndex].length }})</span>
      </h3>
      <div class="meta">
        <span class="category meta-tag">
          {{ fandoms[fandomIndex].categories.join(", ") }}
        </span>
      </div>

      <div>
        <label class="form-switch form-inline">
          <input type="checkbox" v-model="options.useToggles" />
          <i class="form-icon"></i> Use toggles for prompt text
        </label>
        <label class="form-switch form-inline">
          <input type="checkbox" v-model="options.truncateTags" />
          <i class="form-icon"></i> Use toggles for 15+ tags
        </label>
      </div>

      <!-- prompts -->
      <prompt-table v-if="!loading && prompts[fandomIndex]" :prompts="prompts[fandomIndex]"
        :hideCollapseToggle="true"></prompt-table>
    </div>
    <div v-else-if="loading" class="loading"></div>
    <div v-else-if="notFound || fandoms[fandomIndex] == undefined">Fandom not found!</div>
  </div>


</template>

<script>
import axios from "axios";
import { find } from "lodash-es";
import { mapGetters } from "vuex";
import PromptTable from "../components/promptTable";
import utils from "../components/utils.js";
import data from '../store/data'
export default {
  components: { PromptTable },
  computed: {
    ...mapGetters([
      "exchangeId",
      "promptmarks",
      "options",
      "characters",
      "fandoms",
      "prompts",
      "options"
    ]),
  },
  data() {
    return {
      fandom: "",
      fandomIndex: undefined,
      loading: true,
      notFound: false,
    };
  },
  async beforeCreate() {
    let exchangeId = this.$route.params.exchangeId;

    if (!this.exchangeId) {
      this.$store.commit("setExchangeId", exchangeId);
    }
  },
  async beforeMount() {
    this.lookup()
  },
  watch: {
    async $route(to) {
      if (to.name !== "fandom") {
        return;
      }
      this.lookup();
    },
    options: {
      handler(val) {
        this.$store.commit("setOptions", val);
        this.$localStorage.set("appOptions", JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    ...utils,
    async lookup() {
      await this.redirectExchangeId();

      this.loading = true;
      this.notFound = false;
      let exchangeId = this.$route.params.exchangeId;
      let fandom = this.$route.params.id;
      this.fandom = fandom;

      // load fandoms for this exchange if not already present
      if (!this.fandoms || !this.fandoms.length) {
        await data.getExchangeFandoms(exchangeId)
          .then((result) => {
            this.$store.commit("setFandoms", result);
          });
      }

      if (!Number.isInteger(Number(fandom))) {
        let lookup = find(this.fandoms, f => f.name == fandom);
        if (!lookup) {
          this.notFound = true;
          this.fandomIndex = undefined;
          this.loading = false;
          return;
        }

        this.fandomIndex = lookup.index;
      } else {
        this.fandomIndex = Number(fandom);
      }
      try {
        await this.getPrompts(this.$route.params.exchangeId, this.fandomIndex, this.fandom)
      } catch (e) {
        this.notFound = true;
        this.fandom = undefined;
      }
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.bookmark {
  width: 100px;
}
</style>
